import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Деньги для агробизнеса без ежемесячных платежей',
  infoItems: {
    deadline: 'Погашение в конце срока',
    approve: 'Одобряем до 83% заявок',
    fiveDays: 'От заявки до выдачи 5 дней',
    remotely: 'Полностью дистанционно',
  },
} as const satisfies TMessages
